export const setMuroAplication=(state,payload)=>{
    state.muroSelected=payload
}